import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { connect } from "dvajs";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { UserState } from "@/models/user";
import ChatState from "@/types/chat/State";
import { EbookState } from "@/models/ebook";
import { contactRelation } from "@/components/Modals/UserCardModal";
import {
  applyFriend,
  doAcceptFriend,
  getIsSelf,
  onClickAvatar
} from "@/components/UserCard/common";
import log from "@/utils/logger";
import Bus from "@/utils/bus";
import { UserCardV2 } from "@jd/focus-desktop-comps";
// import UserCardV2 from "@/components/Modals/UserCardV2";
import {
  getAllRelationShip,
  getUserEbookDetail,
  setTagForEmpl,
  getTagList,
  setTag
} from "@/api/ebook";
import ImService from "@/server/ImService";
import { examineMobileRecord } from "@/api/addressBook";
import {
  UserCardAction,
  UserCardActionClickInfo,
  UserCardType
} from "@jd/focus-desktop-comps/lib/es/UserCard/UserCardType";
import { pick } from "lodash";
import { appliesNewContacts } from "@/components/AddressBook/common";
import StartLoading from "@/components/StartLoading";
import config, { ChatConfig, ConfigEnum } from "@/config/config";
import { isFocusEnv } from "@/utils";
import WinToolbar from "@/layout/WinToolbar";
import { setEmplFollow } from "@/api/chat";
import { handleRemarkSet } from "@/utils/modals";

import "./index.less";
import { queryEmplReward } from "@/api/reward";

const localUrl = new URL(location.href);
const cid = localUrl.searchParams.get("cid");
const webContentId: any = localUrl.searchParams.get("webContentId");

function UserCardPage({
  userData,
  openCreateContactModal
}: {
  userData: any;
  openCreateContactModal: Function;
}) {
  const { focusSDK, authInfo, permissions } = useContext<GlobalContextConfig>(GlobalContext);
  let platform = focusSDK.getDeviceInfo().platform;

  const [friendErrMsg, setFriendErrMsg] = useState<string>("");
  const [isfriend, setIsFriend] = useState<number>(-1);
  const [visibleFriends, setVisibleFriends] = useState(false);
  const [contactRelationship, setContactRelationship] = useState<contactRelation>({
    contactType: null,
    friendship: 1,
    isEnableAddFriend: true,
    isOnlyScanAdd: false,
    relation: 1,
    isRemove: false
  });
  const [currentEmployeeData, setCurrentEmployeeData] = useState<any>({});

  const [paramProps, setParamProps] = useState<any>(null);

  useEffect(() => {
    focusSDK.openDevTools();
    return () => {};
  }, [focusSDK]);

  const onAppParams = useCallback(
    async (params: any) => {
      log.debug("onAppParams", permissions, params);
      if (!params) {
        return;
      }

      setParamProps({
        ...params,
        appId: params.appId || authInfo.ddAppId,
        type: params.type || UserCardType.CustomUser
      });
    },
    [authInfo.ddAppId, permissions]
  );

  useEffect(() => {
    const dispose1 = focusSDK.addIpcEventListener("app-params", onAppParams);
    log.debug("this is appParams");
    focusSDK.ready();
    return () => {
      dispose1();
    };
  }, [focusSDK, onAppParams]);

  const actionClick = async (props: UserCardActionClickInfo) => {
    const { type, data, accessPhone } = props;
    openCreateContactModal({ visible: false }); // 添加联系人modal关闭
    // Bus.emit("onHideUserCenter"); // 系统管理员列表modal关闭
    switch (type) {
      case UserCardAction.Chat:
        focusSDK.sendTo(webContentId, "openUserCard:reply", cid, type, data);
        return;
      case UserCardAction.Send:
        return await applyFriend(data, accessPhone, currentEmployeeData);
      case UserCardAction.Accept:
        return await doAcceptFriend(data, accessPhone, currentEmployeeData);
      case UserCardAction.Voip:
        focusSDK.sendTo(webContentId, "openUserCard:reply", cid, type, data);
        return;
      case UserCardAction.Jrtc:
        focusSDK.sendTo(webContentId, "openUserCard:reply", cid, type, data);
        return;
      case UserCardAction.Meeting:
        focusSDK.sendTo(webContentId, "openUserCard:reply", cid, type, data);
        return;
      case UserCardAction.Share:
        return focusSDK.sendTo(webContentId, "openUserCard:reply", cid, type, data);
      case UserCardAction.Deleted:
        focusSDK.sendTo(webContentId, "openUserCard:reply", cid, type, data);
        return;
      default:
        break;
    }
    // if (isFocusEnv()) {
    //     return { close: true, data: true };
    // }
    // return true;
    return { close: true, data: true };
  };

  useEffect(() => {
    if (!paramProps) {
      return;
    }
    setIsFriend(-1);
    setFriendErrMsg("");
    setVisibleFriends(false);
    getIsFriends(paramProps.appId, paramProps.userId, paramProps.teamId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paramProps]);

  async function getIsFriends(appId: string, userId: string, teamId: string) {
    let [AllRelationShip, err] = await getAllRelationShip({
      oppoUserId: userId,
      oppoTeamId: teamId,
      appId
    });

    log.debug("getAllRelationShip", AllRelationShip, err);
    if (err) {
      setFriendErrMsg(err);
      return;
    }
    const { friendship, isEnableAddFriend } = AllRelationShip;

    // 是否可添加好友 isEnableAddFriend
    // 好友关系 friendship
    // 同事关系 relation
    // 是否只能扫码添加 isOnlyScanAdd
    // 联系人类型 contactType
    setContactRelationship({
      ...AllRelationShip,
      isRemove:
        (friendship === 1 || friendship === 8) && !getIsSelf(userData, paramProps) ? true : false
    });

    // friendShip:0无友谊（路人），1好友，2黑名单，4被关注（B的好友列表中有A，但是A的好友列表没有B），8单相思（A的好友列表有B，但是B的好友列表没有A）
    // relation:1同事，2陌生人

    // isEnableAddFriend  false 不需要加好友 有可见关系(可见)  true 需要加好友 没有可见关系(不可见)
    // 好友关系如果可见 并且 是同事或者好友 不用添加好友

    if (isEnableAddFriend === false) {
      // 组织可见联系人进行添加联系人的操作
      if (friendship === 1 || friendship === 8) {
        setIsFriend(1);
        return;
      } else if (friendship === 0 || friendship === 4) {
        setVisibleFriends(true);
        setIsFriend(1);
        return;
      } else {
        setIsFriend(0);
        return;
      }
    } else {
      if (friendship === 1 || friendship === 8 || getIsSelf(userData, paramProps)) {
        setIsFriend(1);
        return;
      } else if (friendship === 0 || friendship === 4) {
        setIsFriend(0);
        return;
      }
    }
  }

  const getCurrentData = useCallback(async () => {
    const imService = ImService.getInstance();
    const user: any = await imService.getClientUser({
      teamId: authInfo.teamUserInfo.teamId,
      app: authInfo.ddAppId,
      pin: authInfo.userId
    });
    setCurrentEmployeeData(user);
  }, [authInfo]);

  const getButtons = useMemo(() => {
    //   menuList: [
    //     "chat", // 聊天
    //     "voice", // 音频
    //     "video", // 视频
    //     "share", // 分享名片
    // ]
    if (!paramProps || !paramProps?.menuList || paramProps?.menuList.length === 0) {
      return null;
    }

    return {
      chat: paramProps.menuList.includes("chat"),
      voip:
        paramProps.menuList.includes("voice") &&
        isFocusEnv() &&
        config[ChatConfig.CHAT_SESSION_CREATE_VOIP_ENABLE],
      video: paramProps.menuList.includes("video") && isFocusEnv(),
      webVideo:
        paramProps.menuList.includes("video") &&
        !isFocusEnv() &&
        config[ConfigEnum.CHAT_SESSION_CREATE_JD_VIDEO_ENABLE],
      share: paramProps.menuList.includes("share"),
      add: visibleFriends
    };
  }, [paramProps, visibleFriends]);

  useEffect(() => {
    getCurrentData();
  }, [getCurrentData]);

  const handleSetEmplFollow = useCallback(async (params) => {
    const [res, err] = await setEmplFollow(params);
    if (!err) {
      const imService = ImService.getInstance();
      await imService.updateEmployee([
        {
          pin: params.userIds[0].userId,
          teamId: params.userIds[0].teamId,
          app: params.userIds[0].appId
        }
      ]);
    }
    return [res, err];
  }, []);
  const triggerEvent = (type: string, data?: any) => {
    switch (type) {
      case "showEmplFollowList":
        focusSDK.sendTo(webContentId, "openUserCard:reply", cid, type, data);
        break;
      case "showDepartment":
        focusSDK.sendTo(webContentId, "openUserCard:reply", cid, type, data);
        break;
      default:
        break;
    }
  };
  const onSetTagForEmpl = useCallback((params) => {
    return setTagForEmpl(params);
  }, []);

  let userCardProps = {
    triggerEvent,
    friendErrMsg: friendErrMsg,
    contactRelationship: contactRelationship,
    isfriend: isfriend,
    notPersonalCalendar: true,
    data: paramProps,
    setEmplFollow: handleSetEmplFollow,
    remarkSet: handleRemarkSet,
    currentEmployee: currentEmployeeData,
    onActionClick: actionClick,
    onGetTagList: getTagList,
    onSetTagForEmpl: onSetTagForEmpl,
    onSetTag: setTag,
    onGetUserLevel: async (params: { userId: string; teamId: string; appId: string }) => {
      const res: any = {}; // await queryEmplReward(params);
      return {
        levelName: res?.currentLevel?.levelName || "",
        ext: res?.currentLevel?.ext || "",
        fileUrl: res?.currentLevel?.fileUrl || ""
      };
    },
    openUserLevelDetail: (ext: string) => {
      console.log("ext==>>", ext);
    },
    onGetUserInfo: async (params: {
      userId: string;
      teamId: string;
      appId: string;
      rootOrgId?: string;
    }) => {
      let result: any;
      result = await getUserEbookDetail({
        ...pick(params, ["appId", "userId", "teamId"]),
        isMulti: true,
        isFromBusinessCard: true
      });
      return result || null;
    },
    onClickAvatar: onClickAvatar,
    canAddContact: currentEmployeeData.teamId !== focusSDK.getBjwpConfig()?.teamId,
    appliesNewContacts: appliesNewContacts,
    hideUserCardModal: () => {
      Bus.emit("app:toggle-user-card-modal:hide");
    },
    examineMobileRecord: examineMobileRecord,
    buttons: getButtons
  };

  if (!paramProps || (isfriend === -1 && friendErrMsg === "")) {
    return (
      <div className="flex1 flex-center">
        <StartLoading />
      </div>
    );
  }

  return (
    <div
      className="me-user-card-modal-v2 me-user-card-page-modal"
      style={{
        flex: 1,
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column",
        paddingTop: platform === "win32" ? '30px' : 0
      }}
    >
      {platform === "win32" && (
        <div
          className="draggable"
          style={{
            position: "absolute",
            right: "0",
            top: "0"
          }}
        >
          <WinToolbar isclosewin={true} />
        </div>
      )}
      <UserCardV2 {...userCardProps} />
      <div className="me-user-card-titlebar" />
    </div>
  );
}

function mapStateToProps({
  ebook,
  user,
  chat
}: {
  ebook: EbookState;
  user: UserState;
  chat: ChatState;
}) {
  return {
    addressNavKey: ebook.addressNavKey,
    simpleDeptInfoList: ebook.simpleDeptInfo?.simpleDeptInfoList || null,
    userInfo: {
      app: user.userData.user.ddAppId,
      userId: user.userData.user.userId
    },
    selectedEbookId: ebook.selectedEbookId,
    ebookLoading: ebook.ebookLoading,
    currentEmployee: chat.currentEmployee,
    userData: user.userData.user
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    openCreateContactModal(data: any) {
      dispatch({ type: "ebook/openCreateContactModal", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserCardPage);
